var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"text-success font-semibold",attrs:{"to":`/a/users/${this.params.data.user_id}/progress/${this.params.data.course_id}`}},[_vm._v("Progress")])
}
var staticRenderFns = []

export { render, staticRenderFns }